<table style="table-layout: fixed; width: 100%;" class="table table-xs tableFixHead" id="user-report" *ngIf="reportData.length > 0">
    <thead>
    <tr>
        <th>#</th>
        <th>Name</th>
        <th>Email</th>
        <th>Level</th>
        <th>Status</th>
    </tr>
    </thead>
    <tbody>
        <tr *ngFor="let user of reportData;let index=index">
            <td>{{ index + 1 }}</td>
            <td>{{user.full_name}}</td>
            <td>{{user.email}}</td>
            <td *ngFor="let role of user.roles;let last = last">{{ role.name }}<span *ngIf="!last">&nbsp;,</span></td>
            <td>
                <span class="badge" [ngClass]="user.translated_status.class">
                    {{ user.translated_status.val }}
                </span>
            </td>
        </tr>
    </tbody>
</table>
